import {
  Disclaimer,
  Div,
  EditPenDarkBlueIcon,
  H2,
  Icon,
  IconButtonStyled,
  P,
  Separator,
  VPayLogoBlue,
  centsToDollars,
  formatter,
  lightTheme,
  useUsers,
} from '@vgrubs/components';
import { UserPendingEarningsCreditCardStyled } from '../UsersAndAccessStyled';

export const UserAgentPendingEarningsCreditCard = () => {
  const { setEditPendingBalanceModal, bank } = useUsers((state) => state);

  const handleEditBalanceModal = () => {
    setEditPendingBalanceModal(true);
  };

  return (
    <UserPendingEarningsCreditCardStyled>
      <Div $flex $alignCenter $between $gap="50px" $gapSM="24px">
        <VPayLogoBlue height="100px" width="100px" />
        <Div>
          <P $right $mb="0" $color={lightTheme.blue}>
            Pending Earnings
          </P>
          <P $right $mb="4" $color={lightTheme.lightGray}>
            ({bank?.agentBalance?.date})
          </P>
          <H2 $right $m="0" $color={lightTheme.blue}>
            {formatter.format(
              bank?.agentBalance?.pendingBalance
                ? centsToDollars(bank?.agentBalance?.pendingBalance)
                : 0
            )}
          </H2>
        </Div>
      </Div>
      <Separator $m="24px 0" />
      <Div $flex $alignCenter $between $gap="24px" $gapSM="16px">
        <Div
          $flex
          $alignCenter
          $gap="12px"
          $gapSM="8px"
          onClick={handleEditBalanceModal}
        >
          <IconButtonStyled $color={lightTheme.blue}>
            <Icon $size="24" color={lightTheme.white}>
              <EditPenDarkBlueIcon />
            </Icon>
          </IconButtonStyled>
          <Disclaimer $m="0" $color={lightTheme.blue}>
            Edit Pending <br /> Earnings
          </Disclaimer>
        </Div>
      </Div>
    </UserPendingEarningsCreditCardStyled>
  );
};
